import Vue from "vue";
import VueRouter from "vue-router";
import mainLayout from "@/components/mainLayout";
import index from "./modules/index";
import formwork from "./modules/formwork";
import product from "./modules/product";
import code from "./modules/code";
import agent from "./modules/agent";
import assembly from "./modules/assembly";
import boxing from "./modules/boxing";
import warehouse from "./modules/warehouse";
import goods from "./modules/goods";
import manage from "./modules/manage";
import system from "./modules/system";
import updaterecord from "./modules/updaterecord";
import operationlog from "./modules/operationlog";
import verbuy from "./modules/verbuy";
import usermanage from "./modules/usermanage";

Vue.use(VueRouter);

const router = new VueRouter({
    routes: [
        {
            path: '/admin',
            meta: { title: '首页' },
            component: mainLayout,
            children: [
                ...index,
                formwork,
                product,
                ...code,
                agent,
                ...assembly,
                boxing,
                warehouse,
                goods,
                manage,
                system,
                ...updaterecord,
                ...operationlog,
                ...verbuy,
                usermanage,
            ]
        },
        {
            name: '登录',
            path: '/',
            component: () => import("@/pages/login/login.vue")
        }
    ]
})

router.beforeEach((to, from, next) => {
    window.document.title = "溯源系统";
    next();
})
export default router;